/* eslint-disable react-refresh/only-export-components */

import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from './lib/cn';

const badgeVariants = cva(
  // `shrink-0` — in DataTable flex cells a pill must keep its content width;
  // without it the track compresses and the right edge looks clipped.
  'focus:ring-ring inline-flex shrink-0 items-center rounded-full border px-2.5 py-0.5 text-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/80 border-transparent',
        secondary: 'border-transparent bg-gray-100 text-gray-700 hover:bg-gray-200',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent',
        outline: 'text-foreground border-gray-200',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
